import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const BlackButton = styled(Button)(({ theme }) => ({
  gap: '10px',
  backgroundColor: theme.palette.text.primary,
  textTransform: 'none',
  fontFamily: 'Open Sans',
  fontSize: '14px',
  fontWeight: 400,
  letterSpacing: '1.25px',
  '&:hover': {
    backgroundColor: theme.palette.text.secondary,
  },
}));

export default BlackButton;
